exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".my-custom-scrollbar{position:relative;height:550px;overflow:auto}.my-custom-scrollbar_xAxis{position:relative;height:340px;overflow:auto}.table-wrapper-scroll-y{display:block}.container{flex-wrap:wrap;border:1px solid #ccc;border-radius:8px;padding:55px;margin:1px;background-color:#fff;box-shadow:0 4px 6px rgba(0,0,0,.1)}.item{flex:1;background-color:#f4f4f4;border:1px solid #ddd;border-radius:8px;margin:1px 0;padding:1px;cursor:pointer;transition:background-color .2s ease;border-left-width:thick;-webkit-text-stroke-width:medium;width:max-content;border-bottom-width:thick}.item:hover{background-color:#e0e0e0}.item h2{margin:0;font-size:18px;color:#333}.item p{margin:8px 0;font-size:14px;color:#666}.item button{background-color:#007bff;color:#fff;border:none;border-radius:4px;padding:8px 16px;cursor:pointer;font-size:14px}.item button:hover{background-color:#0056b3}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1d022110","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/common/drag_drop.vue
// module id = 1417
// module chunks = 0